import { useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';
import { PersistentVolumeFilterField } from '@cast/types-stop';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';
import { apiClient } from '@cast/infrastructure-api';

const PERSISTENT_VOLUMES_FILTER_VALUES_QUERY_KEY =
  'persistent-volumes-filter-values';

const PAGE_LIMIT = '9999';

type UsePersistentVolumesFilterValuesQueryArgs = {
  clusterId?: string;
  field: PersistentVolumeFilterField;
  keyword?: string;
  enabled?: boolean;
};

export const usePersistentVolumesFilterValuesQuery = ({
  clusterId,
  field,
  keyword,
  enabled = true,
}: UsePersistentVolumesFilterValuesQueryArgs) => {
  const organizationId = useCurrentOrganizationId();

  return useQuery({
    queryKey: [
      PERSISTENT_VOLUMES_FILTER_VALUES_QUERY_KEY,
      organizationId,
      clusterId,
      field,
      keyword,
    ],
    queryFn: async () => {
      const { data } = await apiClient.stop.searchPersistentVolumeFilterValues({
        organizationId,
        clusterId: clusterId!,
        field,
        keyword,
        pageLimit: PAGE_LIMIT,
      });
      return data?.items;
    },
    enabled: makeIsEnabled(!!organizationId, !!clusterId, enabled),
  });
};
